const pageNameKey = "staticMachineOverviewContainerForTt";

export const staticMachineOverviewContainerForTtEn = {
  [pageNameKey]: {
    job: "Job",
    targetPartQuantityGoodTotal: "Target Part Quantity (Good / Total)",
    progress: "Progress",
    cycleTime: "Cycle Time",
    timeRemaining: "Time Remaining",
    effectiveness: "Effectiveness",
    lastUpdated: "Last updated",
    modeAutomatic: "Automatic",
    noDataAvailable: "No machine data available for past 30 minutes.",
  },
};

export const staticMachineOverviewContainerForTtPtBr = {
  [pageNameKey]: {
    job: "Trabalho",
    targetPartQuantityGoodTotal: "Quantidade alvo de pecas (Boas / Total)",
    progress: "Progresso",
    cycleTime: "Tempo de ciclo",
    timeRemaining: "Tempo restante",
    effectiveness: "Efetividade",
    lastUpdated: "Ultima atualizacao",
    modeAutomatic: "Automatico",
    noDataAvailable: "Sem dados disponíveis",
  },
};

export const staticMachineOverviewContainerForTtDe = {
  [pageNameKey]: {
    job: "Auftrag",
    targetPartQuantityGoodTotal: "Zielteilemenge (Gut / Gesamt)",
    progress: "Fortschritt",
    cycleTime: "Zykluszeit",
    timeRemaining: "Verbleibende Zeit",
    effectiveness: "Effektivitat",
    lastUpdated: "Zuletzt aktualisiert",
    modeAutomatic: "Automatisch",
    noDataAvailable: "Keine Daten verfügbar",
  },
};

export const staticMachineOverviewContainerForTtZhHans = {
  [pageNameKey]: {
    job: "作业",
    targetPartQuantityGoodTotal: "目标零件数量（良品 / 总数）",
    progress: "进度",
    cycleTime: "周期时间",
    timeRemaining: "剩余时间",
    effectiveness: "有效性",
    lastUpdated: "最后更新",
    modeAutomatic: "自动",
    noDataAvailable: "暂无可用数据",
  },
};

export const staticMachineOverviewContainerForTtIt = {
  [pageNameKey]: {
    job: "Lavoro",
    targetPartQuantityGoodTotal: "Quantita target pezzi (Buoni / Totale)",
    progress: "Progresso",
    cycleTime: "Tempo ciclo",
    timeRemaining: "Tempo rimanente",
    effectiveness: "Efficacia",
    lastUpdated: "Ultimo aggiornamento",
    modeAutomatic: "Automatico",
    noDataAvailable: "Nessun dato disponibile",
  },
};

export const staticMachineOverviewContainerForTtEs = {
  [pageNameKey]: {
    job: "Trabajo",
    targetPartQuantityGoodTotal: "Cantidad objetivo de piezas (Buenas / Total)",
    progress: "Progreso",
    cycleTime: "Tiempo de ciclo",
    timeRemaining: "Tiempo restante",
    effectiveness: "Efectividad",
    lastUpdated: "Ultima actualizacion",
    modeAutomatic: "Automatico",
    noDataAvailable: "No hay datos disponibles",
  },
};

export const staticMachineOverviewContainerForTtNl = {
  [pageNameKey]: {
    job: "Taak",
    targetPartQuantityGoodTotal: "Doelonderdelenhoeveelheid (Goed / Totaal)",
    progress: "Voortgang",
    cycleTime: "Cyclustijd",
    timeRemaining: "Resterende tijd",
    effectiveness: "Effectiviteit",
    lastUpdated: "Laatst bijgewerkt",
    modeAutomatic: "Automatisch",
    noDataAvailable: "Geen gegevens beschikbaar",
  },
};

export const staticMachineOverviewContainerForTtTr = {
  [pageNameKey]: {
    cycleTime: "Döngü Süresi",
    effectiveness: "Verimlilik",
    job: "İş",
    lastUpdated: "Son güncelleme",
    modeAutomatic: "Otomatik",
    noDataAvailable: "Son 30 dakikaya ait makine verisi yok.",
    progress: "İlerlemek",
    targetPartQuantityGoodTotal: "Hedef Parça Miktarı (İyi / Toplam)",
    timeRemaining: "Kalan Süre",
  },
};
